module.exports = __webpack_public_path__ + "img/group-user.61b407e5.svg";